import { call, put, takeLatest, all } from "redux-saga/effects";
import { message } from "antd";

import {
  FETCH_ORGANISATIONS_SERVICES,
  FETCH_ORGANISATIONS_SERVICES_SUCCESS,
  FETCH_ORGANISATIONS_SERVICES_ERROR,
} from "../../actions/receptionist/organisationsAction";

import { getOrganisationsServicesAPI } from "../../../services/organisations-service";

function* fetchOrganisationsServices() {
  try {
    const response = yield call(getOrganisationsServicesAPI);

    if (response.success) {
      yield put({
        type: FETCH_ORGANISATIONS_SERVICES_SUCCESS,
        payload: response.data.participant,
      });
    } else {
      message.error("Failed to fetch Organisation services.");

      yield put({
        type: FETCH_ORGANISATIONS_SERVICES_ERROR,
        error: response.error,
      });
    }
  } catch (error) {
    message.error("Failed to fetch Organisation services.");

    yield put({ type: FETCH_ORGANISATIONS_SERVICES_ERROR, error });
  }
}

function* watchFetchOrganisationsServices() {
  yield takeLatest(FETCH_ORGANISATIONS_SERVICES, fetchOrganisationsServices);
}

export default function* rootSaga() {
  yield all([watchFetchOrganisationsServices()]);
}
